import { Actor, HttpAgent, fetchCandid } from '@dfinity/agent'
import { Principal } from '@dfinity/principal'
import getAgent from '@plug-core/utils/getAgent'

export const getCandid = async (canisterId: Principal): Promise<string> => {
  const agent = getAgent()

  return (
    (await fetchCandid(canisterId.toText(), agent)) ??
    ((await Actor.createActor(
      (idl) =>
        idl.IDL.Service({
          __get_candid_interface_tmp_hack: idl.IDL.Func([], [idl.IDL.Text], ['query']),
        }),
      { agent, canisterId }
    ).__get_candid_interface_tmp_hack()) as string)
  )
}
